
import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

export default {
components: {
Group,
XAddress,
XButton,
Cell,
PopupRadio
},
data() {
return {
option1: '本人',
options1: [{
key: 'br',
value: '本人'
}, {
key: 'js',
value: '家属'
}, {
key: 'py',
value: '朋友'
}, {
key: 'qt',
value: '其他'
}
],
option2:  '1',
options2: [{
key: '1',
value: '男'
}, {
key: '2',
value: '女'
}],
age:'',
defaultAddress:false,
showAddress:'',
id: this.$route.query.id,        patientid: this.$store.state.userInfo.id,//患者ID
selectType: this.$route.query.selectType,
orderId:this.$route.query.orderId||'',
paidTypes:this.$route.query.paidTypes||'',
befrom:this.$route.query.befrom||'',
receiver:'' ,//姓名
telephone: '',//联系电话
title: '',
value: [],
addressData: ChinaAddressV4Data,
showAddress: false,
istrue: false,
switchValue1:false,
orederId: this.$route.query.orederId,
}
},

methods: {

deleteAddress(){
let _this=this;
this.$doRequest("/api/inquiryPeople/updateInquiryPeople", {id:this.$route.query.id.id,state:'2'}).then(res => {
if(res.result == 0){
_this.$router.back(-1);
}
})
},
doShowAddress () {
this.showAddress = true
setTimeout(() => {
this.showAddress = false
}, 2000)
},
onShadowChange (val,names) {
this.province = names[0];
this.city = names[1];
this.county = names[2];
},
verify(){
var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;
if(regEn.test(this.receiver) || regCn.test(this.receiver)){
this.$toastMsg('请输入正确格式的联系人');
}
},
verify1(){
if(!(/^1[3456789]\d{9}$/.test( this.telephone ))){
this.$toastMsg('请输入正确格式的手机号');
return;
}
},
updateTop(){
window.scroll(0,0);
},
addAddress(){




if(this.option1=="本人"){
this.option1='br'
}
if(this.$route.query.id&&this.option1!='br'&&this.$route.query.id.relationCode=='br'){
this.$toastMsg('就诊人本人不可更换关系');
return
}
if(this.telephone == ''){
this.$toastMsg('联系方式不能为空');
return;
}
if(this.option1 == '点此选择患者关系'){
this.$toastMsg('请选择患者关系');
return;
}
if(!(/^[0-9]+$/.test( this.age ))||this.age <0 || this.age  > 100){
this.$toastMsg('请输入正确格式的年龄');
return false;
}




if(this.option2=="女"){
this.option2=2
}


let params = {
relationId: this.$store.state.userInfo.id,//患者ID
name: this.receiver,//姓名
age:this.age, //年龄
telephone: this.telephone,//联系电话
isDefault:this.switchValue1?"1":"2",
relationCode:this.option1=="本人"?"br":this.option1,
sex:this.option2=="男"?"1":this.option2,
}
let _this=this;
if(this.$route.query.id){
params.id= this.$route.query.id.id;
this.$doRequest("/api/inquiryPeople/updateInquiryPeople", params).then(res => {
this.$toastMsg('修改成功');
_this.$router.push({path: '/inquiryPeople',query: {orederId: this.orederId,selectType:this.selectType,orderId:this.orderId,befrom: this.befrom,paidTypes:this.paidTypes}});
})
}else{
this.$doRequest("/api/inquiryPeople/insertInquiryPeople", params).then(res => {
if(res.result == 0){

this.$toastMsg('添加成功');
_this.$router.push({path: '/inquiryPeople',query: {orederId: this.orederId,selectType:this.selectType,orderId:this.orderId,befrom: this.befrom,paidTypes:this.paidTypes}});
}
})
}

}
},

created: function(){
document.title =this.$route.query.id?'编辑就诊人': '添加就诊人';
this.$isLogin(window.location.search.substr(1));

},
mounted(){
}
}



// WEBPACK FOOTER //
// ./src/views/inquiryPeopleAdd/indox.vue